<template>
    <v-container fluid>
        <v-layout column class="content">
            <v-layout v-if="anUpdateRequired">
                <v-flex>
                    <div class="update-required-box">
                        <a href="#" @click.stop="updateApp">Actualizar la aplicación</a>
                    </div>
                </v-flex>
            </v-layout>
            <v-layout>
                <img src="../../assets/bitacorapp-logo.png" width="100%" alt="">
            </v-layout>
            <v-layout column>
                <app-menu />
            </v-layout>
        </v-layout>
        
    </v-container>
</template>
<script>

import Menu from './Menu/Menu';

import {mapActions, mapGetters} from 'vuex';
import * as actions from '../../store/actionTypes';
import store from '../../store';
import Cookies from 'js-cookie';

export default {
    name: 'home',
    components: {
        appMenu: Menu
    },
    computed: {
        ...mapGetters(['updateRequired']),
        anUpdateRequired() {
            return !!Cookies.get('bitacorapp_update_required');
        }
    },
    methods: {
        ...mapActions({
            validateVersion: 'VALIDATE_VERSION'
        }),
        updateApp() {
            // this.$store.commit('SET_REQUIRE_UPDATE', false);
            Cookies.remove('bitacorapp_update_required');
            setTimeout(() => location.reload(true), 500);
            // location.reload(true);
        }
    },
    // async beforeRouteEnter(to, from, next) {
        
    //     const version = await store.dispatch('VALIDATE_VERSION');

    //     debugger;
    //     const currentVersion = Cookies.get('bitacorapp_app_version');
    //     if(!currentVersion) {
    //         Cookies.set('bitacorapp_app_version', version, { expires: 365 });
    //         store.commit('SET_REQUIRE_UPDATE', true);
    //     } else {
            
    //         if(currentVersion !== version) {
    //             store.commit('SET_REQUIRE_UPDATE', true);
    //             Cookies.set('bitacorapp_app_version', version, { expires: 365 });
    //         } else {
    //             store.commit('SET_REQUIRE_UPDATE', false);
    //         }
    //     }

    //     next();
    // }
};
</script>
<style scoped>
.content {
    margin-top: 60px;
}
.toolbar {
    left: 0;
    top: 0;
}

.update-required-box {
    padding: 10px;
    border: 1px solid orange;
    border-radius: 3px;
    text-align: center;
    background-color: cornsilk;
    margin: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Home/Home.vue